import React, { FunctionComponent, useEffect } from "react"
import { Controller, FormProvider, useForm } from "react-hook-form"
import { ArtPieceTypes } from "../../api/Definitions"
import FormInput from "../../components/Form/Inputs/FormInput"
import SelectInput from "../../components/Form/Select/Select"
import { iArtist } from "../../definitions/Artists"
import { iArtPieceQuery } from "../../definitions/ArtPieces"
import { iChangeType, iResponse } from "../../definitions/interfaces"
import s from "./ArtPieces.less"
import { get } from "../../store/data/actions"
import AsyncPaginateSelectInput from "../../components/Form/Select/AsyncPaginateSelectInput"
import { isAdmin } from "../../helpers/isAdmin"

interface iProps {
  setQuery: (data: iArtPieceQuery, resetQuery?: boolean) => void
  query: iArtPieceQuery
}

const ArtPieceFilters: FunctionComponent<iProps> = ({ setQuery, query }) => {
  const onChange = ({ name, value }: iChangeType) => {
    setQuery({ [name]: value })
  }

  const loadArtists = async (input: string, skip: number) => {
    try {
      const result = await get<iResponse<iArtist[]>>({
        link: "/v1/artists-list",
        query: { name: input, skip },
      })

      return result
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    methods.reset(query)
  }, [query])

  const methods = useForm({ defaultValues: query })

  return (
    <div className={`filters ${s.filters}`}>
      <div className="filters-form">
        <FormProvider {...methods}>
          <FormInput
            onChange={onChange}
            autoComplete="off"
            name="shrTitle"
            placeholder="Search..."
          />
          <Controller
            name="shrType"
            control={methods.control}
            render={({ value }) => (
              <SelectInput
                name="shrType"
                options={ArtPieceTypes}
                placeholder="Filter by type..."
                isClearable={true}
                value={value}
                onChange={(value) => {
                  onChange({ name: "shrType", value })
                }}
              />
            )}
          />
          <Controller
            name="shrArtistId"
            control={methods.control}
            render={({ value }) => (
              <AsyncPaginateSelectInput
                name="shrArtistId"
                loadOptions={loadArtists}
                defaultOptions
                isClearable={true}
                value={value}
                placeholder="Filter by artist"
                onChange={(value) => {
                  onChange({ name: "shrArtistId", value })
                }}
              />
            )}
          />
          {isAdmin() && (
            <FormInput
              name="public"
              type="checkbox"
              onChange={onChange}
              label="Show Public"
            />
          )}
        </FormProvider>
      </div>
    </div>
  )
}

export default ArtPieceFilters
